export const GET_ORGANISATIONS = 'GET_ORGANISATIONS';
export const GOT_ORGANISATIONS = 'GOT_ORGANISATIONS';

export const GET_ORGANISATION = 'GET_ORGANISATION';
export const ERROR_GET_ORGANISATION = 'ERROR_GET_ORGANISATION';

export const GOT_ORGANISATION = 'GOT_ORGANISATION';
export const GOT_SHORT_URLS = 'GOT_SHORT_URLS';
export const SELECTED_SHORT_URL = 'SELECTED_SHORT_URL';
export const UPDATE_FETCHING_ORGANISATION = 'UPDATE_FETCHING_ORGANISATION';
export const SELECT_ORG_UNIT = 'SELECT_ORG_UNIT';
export const SELECT_ORG_UNIT_ID = 'SELECT_ORG_UNIT_ID';
export const GOT_OU_GC_SETTINGS = 'GOT_OU_GC_SETTINGS';
export const MODIFIED_GC_OU_SETTING_FORM = 'MODIFIED_GC_OU_SETTING_FORM';

export const ERROR_GETTING_ORGANISATIONS = 'ERROR_GETTING_ORGANISATIONS';
export const UPDATED_CURRENT_CREATE_ORG_STEP = 'UPDATED_CURRENT_CREATE_ORG_STEP';
export const UPDATED_CURRENT_FILLED_ORG_STEP = 'UPDATED_CURRENT_FILLED_ORG_STEP';
export const UPDATED_ORG_UNIT_FORM = 'UPDATED_ORG_UNIT_FORM';
export const SHOW_CREATE_ORG_MODAL = 'SHOW_CREATE_ORG_MODAL';
export const HIDE_CREATE_ORG_MODAL = 'HIDE_CREATE_ORG_MODAL';
export const RESET_ORG_UNIT_FORM = 'RESET_ORG_UNIT_FORM';
export const CREATE_ORG_UNIT = 'CREATE_ORG_UNIT';
export const CREATED_ORG_UNIT = 'CREATED_ORG_UNIT';
export const DELETE_ORG_UNIT = 'DELETE_ORG_UNIT';
export const DELETED_ORG_UNIT = 'DELETED_ORG_UNIT';
export const UPDATE_ORGANISATIONAL_UNIT_PERMISSION = 'UPDATE_ORGANISATIONAL_UNIT_PERMISSION';

export const GET_ORG_UNIT_WEBSITE_DETAILS = 'GET_ORG_UNIT_WEBSITE_DETAILS';
export const GOT_ORG_UNIT_WEBSITE_DETAILS = 'GOT_ORG_UNIT_WEBSITE_DETAILS';

export const GET_ORGANISATIONS_WITH_PERMISSION = 'GET_ORGANISATIONS_WITH_PERMISSION';
export const GOT_ORGANISATIONS_WITH_PERMISSION = 'GOT_ORGANISATIONS_WITH_PERMISSION';
export const GOT_ORGANISATIONS_WITH_CREATE_PERMISSION = 'GOT_ORGANISATIONS_WITH_CREATE_PERMISSION';

export const UPDATE_ORG_WEBSITE_BUTTON_DETAILS = 'UPDATE_ORG_WEBSITE_BUTTON_DETAILS';
export const UPDATED_ORG_WEBSITE_BUTTON_DETAILS = 'UPDATED_ORG_WEBSITE_BUTTON_DETAILS';

export const UPDATE_ORG_UNIT_SEARCH = 'UPDATE_ORG_UNIT_SEARCH';
export const GOT_AVAILABLE_ROLES_FOR_ORGANISATIONAL_UNIT = 'GOT_AVAILABLE_ROLES_FOR_ORGANISATIONAL_UNIT';

export const GET_ORGANISATIONAL_UNIT_LOGO_IMAGE = 'GET_ORGANISATIONAL_UNIT_LOGO_IMAGE';
export const GOT_ORGANISATIONAL_UNIT_LOGO_IMAGE = 'GOT_ORGANISATIONAL_UNIT_LOGO_IMAGE';
export const UPDATE_ORGANISATIONAL_UNIT_LOGO_IMAGE_FORM = 'UPDATE_ORGANISATIONAL_UNIT_LOGO_IMAGE_FORM';
export const UPDATE_ORGANISATIONAL_UNIT_LOGO_IMAGE = 'UPDATE_ORGANISATIONAL_UNIT_LOGO_IMAGE';
export const UPDATED_ORGANISATIONAL_UNIT_LOGO_IMAGE = 'UPDATED_ORGANISATIONAL_UNIT_LOGO_IMAGE';
export const GOT_OURECORDING_SETTING_FEATURE = 'GOT_OURECORDING_SETTING_FEATURE';

export const UPDATE_ORGANISATIONAL_UNIT_MEMBER_SEARCH = 'UPDATE_ORGANISATIONAL_UNIT_MEMBER_SEARCH';
/////Manage users
export const UPDATE_ORG_SELECTED_USER_FOR_MANAGEMENT = 'UPDATE_ORG_SELECTED_USER_FOR_MANAGEMENT';
export const UPDATE_ROLES_FOR_SELECTED_USER_IN_ORG_MANAGE_USERS_PAGE =
  'UPDATE_ROLES_FOR_SELECTED_USER_IN_ORG_MANAGE_USERS_PAGE';
////end manage users

export const ORG_UNIT_TAGS = {
  GOT_TAGS: 'ORG_UNIT_TAGS.GOT_TAGS',
  ERROR_GETTING_TAGS: 'ORG_UNIT_TAGS.ERROR_GETTING_TAGS',
  UPDATE_SEARCH_TERM: 'ORG_UNIT_TAGS.UPDATE_SEARCH_TERM',
  GOT_AVAILABLE_TAGS_BY_NETWORKID: 'ORG_UNIT_TAGS.GOT_AVAILABLE_TAGS_BY_NETWORKID',
  ERROR_GETTING_AVAILABLE_TAGS_BY_NETWORKID: 'ORG_UNIT_TAGS.ERROR_GETTING_AVAILABLE_TAGS_BY_NETWORKID',
  CLEAR_TEMP_AVAILABLE_TAGS_OBJECT: 'ORG_UNIT_TAGS.CLEAR_TEMP_AVAILABLE_TAGS_OBJECT',
  UPDATE_SELECTED_TAG_FOR_MANAGEMENT: 'ORG_UNIT_TAGS.UPDATE_SELECTED_TAG_FOR_MANAGEMENT',
  UPDATE_ASSIGN_TAG_VALUES_FORM: 'ORG_UNIT_TAGS.UPDATE_ASSIGN_TAG_VALUES_FORM',
  CLEAR_TEMP_ASSIGN_TAGS_OBJECT: 'ORG_UNIT_TAGS.CLEAR_TEMP_ASSIGN_TAGS_OBJECT',
};

export const ADD_USERS_FORM = {
  SELECT_ROLE: 'ADD_USERS_FORM.SELECT_ROLE',
  UNSELECT_ROLE: 'ADD_USERS_FORM.UNSELECT_ROLE',
  UPDATE_MESSAGE: 'ADD_USERS_FORM.UPDATE_MESSAGE',
  CLEAR_FORM: 'ADD_USERS_FORM.CLEAR_FORM',
  ADDING_USERS_TO_ORGANISATIONAL_UNIT: 'ADD_USERS_FORM.ADDING_USERS_TO_ORGANISATIONAL_UNIT',
};

// Org Unit general info
export const GENERAL_INFO_FORM = {
  GOT_GENERAL_INFO_FORM: 'GOT_GENERAL_INFO_FORM',
  UPDATE_EDIT_GENERAL_INFO_FORM: 'UPDATE_EDIT_GENERAL_INFO_FORM',
  SAVE_EDIT_GENERAL_INFO_FORM: 'SAVE_EDIT_GENERAL_INFO_FORM',
  ORG_NAME_DUPLICATE: 'ORG_NAME_DUPLICATE',
  SET_ORG_UNIT_GENERAL_INFO_FORM_TRIM: 'SET_ORG_UNIT_GENERAL_INFO_FORM_TRIM',
};

export const CLEAR_ORG_UNIT_GENERAL_INFO_FORM = 'CLEAR_ORG_UNIT_GENERAL_INFO_FORM';

export const ORG_UNIT_SUPPORT_CONTACT = {
  GOT_ORG_UNIT_SUPPORT_CONTACT_INFO: 'GOT_ORG_UNIT_SUPPORT_CONTACT_INFO',
  CHANGE_ORG_UNIT_SUPPORT_CONTACT_INFO: 'CHANGE_ORG_UNIT_SUPPORT_CONTACT_INFO',
};

// Org Unit Before Calls for WA
export const GET_ORGANISATIONAL_UNIT_BEFORE_CALLS_FOR_WA = 'GET_ORGANISATIONAL_UNIT_BEFORE_CALLS_FOR_WA';
export const GOT_ORGANISATIONAL_UNIT_BEFORE_CALLS_FOR_WA = 'GOT_ORGANISATIONAL_UNIT_BEFORE_CALLS_FOR_WA';
export const MODIFIED_ORGANISATIONAL_UNIT_BEFORE_CALLS_FOR_WA = 'MODIFIED_ORGANISATIONAL_UNIT_BEFORE_CALLS_FOR_WA';

// Org Unit Share Link message for WA
export const GOT_SHARE_LINK_MESSAGE_FOR_WA = 'GOT_SHARE_LINK_MESSAGE_FOR_WA';

// Entity admin
export const GOT_ALL_ENTITIES_PAGINATION = 'GOT_ALL_ENTITIES_PAGINATION';
export const ERROR_GETTING_ALL_ENTITIES = 'ERROR_GETTING_ALL_ENTITIES';
export const RESET_ENTITY_SEARCH_FROM = 'RESET_ENTITY_SEARCH_FROM';
export const UPDATE_ENTITY_SEARCH_FROM = 'UPDATE_ENTITY_SEARCH_FROM';
export const UPDATE_CURRENT_ACTIVE_PAGENO_FOR_ENTITY_PAGE = 'UPDATE_CURRENT_ACTIVE_PAGENO_FOR_ENTITY_PAGE';
export const IS_ON_ENTITY_LISTING_PAGE = 'IS_ON_ENTITY_LISTING_PAGE';
export const GOT_ALL_WA_ENTITIES_PAGINATION = 'GOT_ALL_WA_ENTITIES_PAGINATION';
export const GOT_ALL_MR_ENTITIES_PAGINATION = 'GOT_ALL_MR_ENTITIES_PAGINATION';
export const IS_FETCHING_WA_ENTITIES = 'IS_FETCHING_WA_ENTITIES';
export const GOT_WAITING_AREA_BY_SEARCH_TERM = 'GOT_WAITING_AREA_BY_SEARCH_TERM';
export const DELETED_WAITING_AREA_FROM_ORG = 'DELETED_WAITING_AREA_FROM_ORG';
export const GOT_MEETING_ROOM_BY_ID_AND_SEARCH_TERM = 'GOT_MEETING_ROOM_BY_ID_AND_SEARCH_TERM';
export const DELETED_MEETING_ROOM_FROM_ORG = 'DELETED_MEETING_ROOM_FROM_ORG';
export const UPDATE_RHS_TOTAL_COUNT = 'UPDATE_RHS_TOTAL_COUNT';
export const UPDATE_FILTER_VALUE = 'UPDATE_FILTER_VALUE';

export const REMOVE_DELETED_ORGANIZATION = 'REMOVE_DELETED_ORGANIZATION';

export const SET_MEETING_ROOMS_DELETION_STATUS = 'SET_MEETING_ROOMS_DELETION_STATUS';
export const SET_WAITING_AREAS_DELETION_STATUS = 'SET_WAITING_AREAS_DELETION_STATUS';
export const SET_ORGANIZATION_DELETION_STATUS = 'SET_ORGANIZATION_DELETION_STATUS';

import { displayGlobalMessage } from '../actions/globalMessage';
import { getAuthHeaders } from '../businessLogic/authorizator';
import fc from '../businessLogic/fetchInterceptor';
import { getOrganisationalUnitUsers, SEARCH_SELECT_USERS_FORM } from './user';
import { showHideOrganisationalUnitAddUsersModal, showOrganisationalUnitLogoImageModal } from '../actions/modal';
import { CONSULT_NOW_TOGGLE } from './shared';
import { queueESEvents, ESEventTypes } from 'businessLogic/logEventToElasticSearch';
export function createOrgUnit(orgUnitFormData, cb) {
  return (dispatch) => {
    dispatch({ type: CREATE_ORG_UNIT });

    fc.post(window.APP.CONFIGURATION.VCCAPI + 'organisations', {
      body: JSON.stringify(orgUnitFormData),
    })
      .then((data) => {
        if (cb) cb();
        dispatch({ type: CREATED_ORG_UNIT, data: data });
        var successMessage = APP.LANGUAGE.CreateUpdateMeetingRoom.CreateMeetingRoomSuccess.replace(
          '##meetingRoomName##',
          orgUnitFormData.name
        );
        dispatch(
          displayGlobalMessage({
            text: successMessage,
            visible: true,
            messageType: APP.LANGUAGE.GlobalMessageTypes.Good,
            autoHide: true,
          })
        );
      })
      .catch((err, resp) => {
        var error =
          APP.LANGUAGE.ServerErrors[err.message] ||
          APP.LANGUAGE.Errors[err.message] ||
          APP.LANGUAGE.ServerErrors.GeneralApiError;
        // var error = error ? error : APP.LANGUAGE.ServerErrors.GeneralApiError;//will replace it from generic message
        dispatch(
          displayGlobalMessage({
            text: error,
            visible: true,
            messageType: APP.LANGUAGE.GlobalMessageTypes.Bad,
            autoHide: false,
            apiURL: window.APP.CONFIGURATION.VCCAPI + 'organisations',
            browserURL: window.location.href,
          })
        );

        console.error('There was an API error', err.toString());
      });
  };
}

export function createOUByAdmin(payload, cb) {
  return (dispatch) => {
    fc.post(window.APP.CONFIGURATION.VCCAPI + 'organisations/createOrganisationalUnit', {
      body: JSON.stringify(payload),
    })
      .then((data) => {
        let successMessage = APP.LANGUAGE.CreateOU.SuccessfulMessage.replace('##OUName##', payload.name);
        dispatch(
          displayGlobalMessage({
            text: successMessage,
            visible: true,
            messageType: APP.LANGUAGE.GlobalMessageTypes.Good,
            autoHide: true,
          })
        );
        if (cb) cb(true, data);
      })
      .catch((err, response) => {
        console.error('There was an API error', err.toString());
        if (err == APP.LANGUAGE.CreateOU.OrgNameDuplicateError) {
          let orgNameDuplicate = APP.LANGUAGE.CreateOU.OrgNameDuplicateBadMessage;
          dispatch(
            displayGlobalMessage({
              text: orgNameDuplicate,
              visible: true,
              messageType: APP.LANGUAGE.GlobalMessageTypes.Bad,
              autoHide: false,
              apiURL: window.APP.CONFIGURATION.VCCAPI + 'organisations/createOrganisationalUnit',
              browserURL: window.location.href,
            })
          );
        } else if (err == APP.LANGUAGE.CreateOU.OrgAbbreviationDuplicateError) {
          let orgNameDuplicate = APP.LANGUAGE.CreateOU.OrgAbbrevDuplicateBadMessage;
          dispatch(
            displayGlobalMessage({
              text: orgNameDuplicate,
              visible: true,
              messageType: APP.LANGUAGE.GlobalMessageTypes.Bad,
              autoHide: false,
              apiURL: window.APP.CONFIGURATION.VCCAPI + 'organisations/createOrganisationalUnit',
              browserURL: window.location.href,
            })
          );
        }
        if (cb) cb(false);
      });
  };
}

export function updateOrgUnit(orgUnitFormData, cb) {
  return (dispatch) => {
    dispatch({ type: CREATE_ORG_UNIT });

    fc.put(window.APP.CONFIGURATION.VCCAPI + 'organisations/' + orgUnitFormData.id, {
      body: JSON.stringify(orgUnitFormData),
    })
      .then((data) => {
        if (cb) cb();
        dispatch({ type: CREATED_ORG_UNIT, data: data });
        var successMessage = APP.LANGUAGE.CreateUpdateMeetingRoom.CreateMeetingRoomSuccess.replace(
          '##meetingRoomName##',
          orgUnitFormData.name
        );
        dispatch(
          displayGlobalMessage({
            text: successMessage,
            visible: true,
            messageType: APP.LANGUAGE.GlobalMessageTypes.Good,
            autoHide: true,
          })
        );
      })
      .catch((err, resp) => {
        var error =
          APP.LANGUAGE.ServerErrors[err.message] ||
          APP.LANGUAGE.Errors[err.message] ||
          APP.LANGUAGE.ServerErrors.GeneralApiError;
        // var error = error ? error : APP.LANGUAGE.ServerErrors.GeneralApiError;//will replace it from generic message
        dispatch(
          displayGlobalMessage({
            text: error,
            visible: true,
            messageType: APP.LANGUAGE.GlobalMessageTypes.Bad,
            autoHide: false,
            apiURL: window.APP.CONFIGURATION.VCCAPI + 'organisations/' + orgUnitFormData.id,
            browserURL: window.location.href,
          })
        );

        console.error('There was an API error', err.toString());
      });
  };
}

export function getOrganisations(cb) {
  return (dispatch) => {
    dispatch({ type: GET_ORGANISATIONS });
    var apiPart = 'organisations';
    fc.get(window.APP.CONFIGURATION.VCCAPI + apiPart)
      .then((data) => {
        let res = dispatch({ type: GOT_ORGANISATIONS, data: data });
        if (cb) cb();
        return res;
      })
      .catch((err) => console.error('There was an error getting the organisations', err.toString()));
  };
}

export function getOrganisationById(id, cb) {
  return (dispatch) => {
    dispatch({ type: GET_ORGANISATION, data: id });

    var apiPart = 'organisations/' + id;
    fc.get(window.APP.CONFIGURATION.VCCAPI + apiPart)
      .then((data) => {
        let organisations = [];
        let res = dispatch({ type: GOT_ORGANISATION, data: data });
        if (cb) cb(data);
        return res;
      })
      .catch((err) => {
        dispatch({ type: ERROR_GET_ORGANISATION });
        console.error('There was an error getting the organisations', err.toString());
      });
  };
}
export function getShortUrls(cb) {
  return (dispatch) => {
    var apiPart = 'organisations/GetOrganisationUrlOptions';
    fc.get(window.APP.CONFIGURATION.VCCAPI + apiPart)
      .then((data) => {
        if (data) {
          let res = dispatch({ type: GOT_SHORT_URLS, data: data });
          dispatch(selectedShortUrl(data[0].url));
          if (cb) cb(data);
          return res;
        }
      })
      .catch((err) => {
        console.error('There was an error getting the organisations', err.toString());
      });
  };
}
export function selectedShortUrl(data) {
  return (dispatch) => {
    dispatch({ type: SELECTED_SHORT_URL, data: data });
  };
}

export function updateFetchingOrg(isFetching) {
  return (dispatch) => {
    return dispatch({ type: UPDATE_FETCHING_ORGANISATION, data: isFetching });
  };
}

export function getOrganisationsWithPermission(permission, cb) {
  return (dispatch) => {
    dispatch({ type: GET_ORGANISATIONS_WITH_PERMISSION });
    var apiPart = 'organisations';
    if (permission)
      //if some Permission param is being sent
      apiPart += '/' + permission;
    fc.get(window.APP.CONFIGURATION.VCCAPI + apiPart)
      .then((data) => {
        let res = null;

        if (permission == APP.LANGUAGE.Permission.CREATE_GROUP)
          res = dispatch({
            type: GOT_ORGANISATIONS_WITH_CREATE_PERMISSION,
            data: data,
          });

        if (cb) cb();
        return res;
      })
      .catch((err) => console.error('There was an error getting org units', err.toString()));
  };
}

export function resetOrgUnitForm() {
  return (dispatch) => {
    dispatch({ type: RESET_ORG_UNIT_FORM });
  };
}

export function updateCurrentFilledCreateOrgSteps(createOrgStepsFilled) {
  return (dispatch) => {
    dispatch({
      type: UPDATED_CURRENT_FILLED_ORG_STEP,
      data: createOrgStepsFilled,
    });
  };
}

export function updateOrganisationalUnitPermission(data) {
  return (dispatch) => {
    dispatch({ type: UPDATE_ORGANISATIONAL_UNIT_PERMISSION, data: data });
  };
}

export function updateCurrentCreateOrgStep(step) {
  return (dispatch) => {
    dispatch({ type: UPDATED_CURRENT_CREATE_ORG_STEP, data: step });
  };
}

export function updateOrgUnitForm(orgUnitFormChanged) {
  return (dispatch) => {
    dispatch({ type: UPDATED_ORG_UNIT_FORM, data: orgUnitFormChanged });
  };
}

export function deleteOrgUnit(orgInfo, cb) {
  return (dispatch) => {
    dispatch({ type: DELETE_ORG_UNIT });

    var apiParam = 'organisations/' + orgInfo.networkId;
    // permission check should happen in UI rendering stage
    // async call to delete the org
    console.warn('sent req for deleting org:', window.APP.CONFIGURATION.VCCAPI + apiParam);
    fc.delete(window.APP.CONFIGURATION.VCCAPI + apiParam)
      .then((data) => {
        // remove from list
        let res = dispatch({ type: DELETED_ORG_UNIT, data: orgInfo.networkId });
        // if you have callback, run it
        // note that before run this, the ui already removed the upper item
        if (cb) {
          cb();
        }
        // show notification message
        let successMessage = APP.LANGUAGE.DeleteOrg.DeleteOrgSuccess.replace('##orgName##', orgInfo.name);
        dispatch(
          displayGlobalMessage({
            text: successMessage,
            visible: true,
            messageType: APP.LANGUAGE.GlobalMessageTypes.Good,
            autoHide: true,
          })
        );
      })
      .catch((err) => {
        var error =
          APP.LANGUAGE.ServerErrors[err.message] ||
          APP.LANGUAGE.Errors[err.message] ||
          APP.LANGUAGE.ServerErrors.GeneralApiError;
        // var error = error ? error : APP.LANGUAGE.ServerErrors.GeneralApiError;//will replace it from generic message
        dispatch(
          displayGlobalMessage({
            text: error,
            visible: true,
            messageType: APP.LANGUAGE.GlobalMessageTypes.Bad,
            autoHide: false,
            apiURL: window.APP.CONFIGURATION.VCCAPI + apiParam,
            browserURL: window.location.href,
          })
        );
        // dispatch({ type: RESET_SAVING_FLAG })//TODO: should use organisation specific reset fetching flag
        console.error('There was an API error', err.toString());
      });
  };
}

export function updateOrgUnitSearch(searchTerm) {
  return (dispatch) => {
    dispatch({ type: UPDATE_ORG_UNIT_SEARCH, data: searchTerm });
  };
}

export function getOrgWebsiteButtonDetails(orgId, cb) {
  return (dispatch) => {
    dispatch({ type: GET_ORG_UNIT_WEBSITE_DETAILS });
    var apiPart = 'organisations/' + orgId + '/websiteButton';
    fetch(window.APP.CONFIGURATION.VCCAPI + apiPart, {
      headers: getAuthHeaders(),
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        if (cb) cb();
        let res = dispatch({ type: GOT_ORG_UNIT_WEBSITE_DETAILS, data: data });
        return res;
      })
      .catch((err) => console.error('There was an error getting the organisations', err.toString()));
  };
}

export function updateOrgWebsiteButton(orgWebsiteButtonDetails, cb) {
  return (dispatch) => {
    dispatch({ type: UPDATE_ORG_WEBSITE_BUTTON_DETAILS });
    fetch(window.APP.CONFIGURATION.VCCAPI + 'organisations/webButtonDetails', {
      method: 'POST',
      body: JSON.stringify(orgWebsiteButtonDetails),
      headers: getAuthHeaders(),
    })
      .then((response) => {
        if (!response.ok) throw Error(response.statusText);
      })
      .then((data) => {
        if (cb) cb();
        dispatch({
          type: UPDATED_ORG_WEBSITE_BUTTON_DETAILS,
          data: orgWebsiteButtonDetails,
        });
        var successMessage = APP.LANGUAGE.CreateOrgUnitWebsiteButton.CreateOrgUnitWebsiteButtonSuccess;
        dispatch(
          displayGlobalMessage({
            text: successMessage,
            visible: true,
            messageType: APP.LANGUAGE.GlobalMessageTypes.Good,
            autoHide: true,
          })
        );
      })
      .catch((err, resp) => {
        var error =
          APP.LANGUAGE.ServerErrors[err.message] ||
          APP.LANGUAGE.Errors[err.message] ||
          APP.LANGUAGE.ServerErrors.GeneralApiError;
        // var error = error ? error : APP.LANGUAGE.ServerErrors.GeneralApiError;//will replace it from generic message
        dispatch(
          displayGlobalMessage({
            text: error,
            visible: true,
            messageType: APP.LANGUAGE.GlobalMessageTypes.Bad,
            autoHide: false,
            apiURL: window.APP.CONFIGURATION.VCCAPI + 'organisations/webButtonDetails',
            browserURL: window.location.href,
          })
        );
        dispatch({ type: UPDATED_ORG_WEBSITE_BUTTON_DETAILS }); //TODO: should use organisation specific reset fetching flag
        console.error('There was an API error', err.toString());
      });
  };
}

export function selectOrgUnitId(orgNetworkId, cb) {
  return (dispatch) => {
    return dispatch({ type: SELECT_ORG_UNIT_ID, data: orgNetworkId });
  };
}
export function selectOrgUnit(orgNetwork, cb) {
  return (dispatch) => {
    return dispatch({ type: SELECT_ORG_UNIT, data: orgNetwork });
  };
}

export function getOrgUnitTags(networkId, cb) {
  return (dispatch) => {
    let errorCallback = (response) => {
      console.error('ERROR', response);
      dispatch({ type: ORG_UNIT_TAGS.ERROR_GETTING_TAGS });
    };

    const url = window.APP.CONFIGURATION.VCCAPI + 'tags/network/' + networkId;

    fc.get(url)
      .then((data) => {
        if (cb) cb();
        let res = dispatch({
          type: ORG_UNIT_TAGS.GOT_TAGS,
          data: {
            tags: data,
            networkId: networkId,
          },
        });

        return res;
      })
      .catch((err) => errorCallback(err));
  };
}

export function updateOrgUnitTagSearch(searchTerm) {
  return (dispatch) => {
    dispatch({ type: ORG_UNIT_TAGS.UPDATE_SEARCH_TERM, data: searchTerm });
  };
}

// OU Manage tags
export function updateSelectedTagInOU(tagObject, cb) {
  return (dispatch) => {
    dispatch({
      type: ORG_UNIT_TAGS.UPDATE_SELECTED_TAG_FOR_MANAGEMENT,
      data: tagObject,
    });
    if (cb) cb();
  };
}

export function clearTempAssignTagsObjectInOU() {
  return (dispatch) => {
    dispatch({ type: ORG_UNIT_TAGS.CLEAR_TEMP_ASSIGN_TAGS_OBJECT });
  };
}

export function deleteTagFromOU(orgUnitId, deleteTagObject, cb) {
  return (dispatch) => {
    const apiParam = 'tags/' + deleteTagObject.tagId + '/unassign/' + orgUnitId;
    fc.put(window.APP.CONFIGURATION.VCCAPI + apiParam)
      .then((data) => {
        if (cb) cb(false);
      })
      .catch((err) => {
        console.error('There was an API error', err.toString());
        if (cb) {
          cb(true);
        }
      });
  };
}

export function getAvailableTagsByNetworkId(networkId, cb) {
  return (dispatch) => {
    let errorCallback = (response) => {
      console.error('ERROR', response);
      dispatch({
        type: ORG_UNIT_TAGS.ERROR_GETTING_AVAILABLE_TAGS_BY_NETWORKID,
      });
    };

    const apiPart = 'tags/network/' + networkId + '/availabletags';
    fc.get(window.APP.CONFIGURATION.VCCAPI + apiPart)
      .then((data) => {
        dispatch({
          type: ORG_UNIT_TAGS.GOT_AVAILABLE_TAGS_BY_NETWORKID,
          data: {
            availableTags: data,
            networkId: networkId,
          },
        });
        if (cb) cb(data);
      })
      .catch((err) => {
        (err) => errorCallback(err);
      });
  };
}

export function updateAsssignedValuesByTagIdInOU(tagValuesObject, cb) {
  return (dispatch) => {
    dispatch({
      type: ORG_UNIT_TAGS.UPDATE_ASSIGN_TAG_VALUES_FORM,
      data: tagValuesObject,
    });
    if (cb) cb();
  };
}

export function getAvailableTagsByTagIdInOU(tagId) {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      let errorCallback = (response) => {
        console.error('ERROR', response);
        dispatch({ type: ORG_UNIT_TAGS.ERROR_GETTING_AVAILABLE_TAGS_BY_TAGID });
        reject('ERROR');
      };

      const apiPart = 'tags/' + tagId;
      fc.get(window.APP.CONFIGURATION.VCCAPI + apiPart)
        .then((data) => {
          dispatch({
            type: ORG_UNIT_TAGS.UPDATE_SELECTED_TAG_FOR_MANAGEMENT,
            data: {
              tagId: data.tagId,
              tagName: data.tagName,
              description: data.description,
              canMultiSelect: data.canMultiSelect,
              availableTagValues: data.tagValues,
            },
          });
          resolve(dispatch);
        })
        .catch((err) => {
          (err) => errorCallback(err);
        });
    });
  };
}

export function saveEditTagsInOU(networkId, editedTagObject, cb) {
  return (dispatch) => {
    const apiPart = 'tags/network/' + networkId + '/update';
    let payload = {
      tagId: editedTagObject.tagId,
      addedValues: editedTagObject.addedValues,
      removedValues: editedTagObject.removedValues,
    };
    fc.put(window.APP.CONFIGURATION.VCCAPI + apiPart, {
      body: JSON.stringify(payload),
    })
      .then((data) => {
        if (cb) cb(false);
      })
      .catch((err) => {
        console.error('There was an API error', err.toString());
        if (cb) {
          cb(true);
        }
      });
  };
}

export function saveAssignTagsInOU(networkId, addedTagObject, cb) {
  let errorHandler = (err) => {
    console.error('There was an API error', err.toString());
    if (cb) {
      cb(true);
    }
  };
  return (dispatch) => {
    const apiPart = 'tags/network/' + networkId + '/assign';
    let payload = {
      tagId: addedTagObject.tagId,
      addedValues: addedTagObject.addedValues,
    };
    fc.put(window.APP.CONFIGURATION.VCCAPI + apiPart, {
      body: JSON.stringify(payload),
    })
      .then((data) => {
        if (cb) cb(false);
      })
      .catch((err) => {
        errorHandler(err);
      });
  };
}

export function updateOrganisationalUnitMemberSearch(searchTerm) {
  return (dispatch) => {
    dispatch({
      type: UPDATE_ORGANISATIONAL_UNIT_MEMBER_SEARCH,
      data: searchTerm,
    });
  };
}

/* Manage avaible role names */
export function getAvailableRoles(orgNetworkId) {
  return (dispatch) => {
    let apiPath = 'organisations/' + orgNetworkId + '/Roles';
    fc.get(window.APP.CONFIGURATION.VCCAPI + apiPath)
      .then((data) => {
        return dispatch({
          type: GOT_AVAILABLE_ROLES_FOR_ORGANISATIONAL_UNIT,
          data: data,
        });
      })
      .catch((err) => {
        console.error('There was an API error', err.toString());
      });
  };
}

export function setManageRoleForm(rolesArray) {
  return (dispatch) => {
    dispatch({
      type: UPDATE_ROLES_FOR_SELECTED_USER_IN_ORG_MANAGE_USERS_PAGE,
      data: rolesArray,
    });
  };
}

/* Manage roles For users list */
export function updateSelectedUser(userId, cb) {
  return (dispatch) => {
    dispatch({ type: UPDATE_ORG_SELECTED_USER_FOR_MANAGEMENT, data: userId });
    if (cb) cb();
  };
}

export function resendInvitionToOrganisationalUnit(organisation, user) {
  return (dispatch) => {
    // Call VCC API
    const apiParam = 'organisations/' + organisation.networkId + '/resendinvitation/' + user.id;
    fc.put(window.APP.CONFIGURATION.VCCAPI + apiParam)
      .then((res) => {
        let cbForGetUsers = () => {
          // show success message
          dispatch(
            displayGlobalMessage({
              text: APP.LANGUAGE.OrganisationalUnitUserActionMenu.ResendInviteSuccessMessage,
              visible: true,
              messageType: APP.LANGUAGE.GlobalMessageTypes.Good,
              autoHide: true,
            })
          );
        };

        // re-fetch the organisational unit users list
        dispatch(getOrganisationalUnitUsers(organisation.networkId, cbForGetUsers));
      })
      .catch((err) => {
        console.error('There was an API error', err.toString());
      });
  };
}

export function cancelInvitionToOrganisationalUnit(organisation, user) {
  return (dispatch) => {
    // Call VCC API
    const apiParam = 'organisations/' + organisation.networkId + '/cancelinvitation/' + user.id;
    fc.put(window.APP.CONFIGURATION.VCCAPI + apiParam)
      .then((res) => {
        let cbForGetUsers = () => {
          // show success message
          dispatch(
            displayGlobalMessage({
              text: APP.LANGUAGE.OrganisationalUnitUserActionMenu.CancelInviteSuccessMessage,
              visible: true,
              messageType: APP.LANGUAGE.GlobalMessageTypes.Good,
              autoHide: true,
            })
          );
        };

        // re-fetch the organisational unit users list
        dispatch(getOrganisationalUnitUsers(organisation.networkId, cbForGetUsers));
      })
      .catch((err) => {
        console.error('There was an API error', err.toString());
      });
  };
}

export function selectRoleAddUsersForm(roleId) {
  return (dispatch) => {
    return dispatch({
      type: ADD_USERS_FORM.SELECT_ROLE,
      data: roleId,
    });
  };
}

export function unSelectRoleAddUsersForm(roleId) {
  return (dispatch) => {
    return dispatch({
      type: ADD_USERS_FORM.UNSELECT_ROLE,
      data: roleId,
    });
  };
}

export function updateMessageAddUsersForm(message) {
  return (dispatch) => {
    return dispatch({
      type: ADD_USERS_FORM.UPDATE_MESSAGE,
      data: message,
    });
  };
}

export function clearAddUsersForm() {
  return (dispatch) => {
    return dispatch({
      type: ADD_USERS_FORM.CLEAR_FORM,
    });
  };
}

export function addUsersToOrganisationalUnit(organisation, model, cb) {
  return (dispatch) => {
    // Update UI to show adding in progress
    dispatch({
      type: ADD_USERS_FORM.ADDING_USERS_TO_ORGANISATIONAL_UNIT,
      data: organisation.networkId,
    });

    // Call VCC API
    const apiParam = 'organisations/' + organisation.networkId + '/addusers';
    fc.put(window.APP.CONFIGURATION.VCCAPI + apiParam, {
      body: JSON.stringify(model),
    })
      .then((res) => {
        let cbForGetUsers = () => {
          // show success message
          const totalUsersAdded = model.userInvites.length + model.emailInvites.length;
          const successMessage =
            totalUsersAdded > 1
              ? APP.LANGUAGE.OrganisationalUnitAddUsersModal.MultipleUserAddedSuccess.replace(
                  '##entityName##',
                  organisation.name
                )
              : APP.LANGUAGE.OrganisationalUnitAddUsersModal.SingleUserAddedSuccess.replace(
                  '##entityName##',
                  organisation.name
                );

          dispatch(
            displayGlobalMessage({
              text: successMessage,
              visible: true,
              messageType: APP.LANGUAGE.GlobalMessageTypes.Good,
              autoHide: true,
            })
          );

          // udpate redux state
          dispatch({
            type: ADD_USERS_FORM.CLEAR_FORM,
          });

          dispatch({
            type: SEARCH_SELECT_USERS_FORM.CLEAR_FORM,
          });
          if (cb) cb();
          dispatch(showHideOrganisationalUnitAddUsersModal(false));
        };

        // re-fetch the Organisation  users list
        dispatch(getOrganisationalUnitUsers(organisation.networkId, cbForGetUsers));
      })
      .catch((err) => {
        console.error('There was an API error', err.toString());
        if (cb) cb();
      });
  };
}

// General information
export function getOrgUnitGeneralInfo(orgUnitId, cb) {
  return (dispatch) => {
    let apiPath = 'organisations/' + orgUnitId + '/Generalinfo';
    fc.get(window.APP.CONFIGURATION.VCCAPI + apiPath)
      .then((data) => {
        let orgUnitGeneralInfoForm = {
          name: data.name,
          abbreviatedName: data.abbreviatedName,
          termsAndConditionUrl: data.termsAndConditionUrl,
          troubleshootingUrl: data.troubleshootingUrl,
          privacyPolicyUrl: data.privacyPolicyUrl,
          callerEntryPage: data.callerEntryPage,
          orgNameDuplicate: false,
          featuresEnabled: data.featuresEnabled,
          providerUrl: data.providerUrl,
        };
        dispatch({
          type: GENERAL_INFO_FORM.GOT_GENERAL_INFO_FORM,
          data: { id: data.id, orgUnitGeneralInfoForm: orgUnitGeneralInfoForm },
        });
        if (cb) cb();
      })
      .catch((err) => {
        console.error('There was an API error', err.toString());
      });
  };
}

export function removeDeletedOrganization(org) {
  return (dispatch) => {
    return dispatch({
      type: REMOVE_DELETED_ORGANIZATION,
      data: org,
    });
  };
}

export function setMeetingRoomsDeletionStatus(status) {
  return (dispatch) => {
    return dispatch({
      type: SET_MEETING_ROOMS_DELETION_STATUS,
      data: status,
    });
  };
}

export function setWaitingRoomsDeletionStatus(status) {
  return (dispatch) => {
    return dispatch({
      type: SET_WAITING_AREAS_DELETION_STATUS,
      data: status,
    });
  };
}

export function setOrganizationDeletionStatus(status) {
  return (dispatch) => {
    return dispatch({
      type: SET_ORGANIZATION_DELETION_STATUS,
      data: status,
    });
  };
}

export function deleteOrganization(org, closeConfirmationModal, cbAfterDeletion) {
  return (dispatch) => {
    dispatch(setOrganizationDeletionStatus(APP.LANGUAGE.API_CALL_STATUS.IN_PROGRESS));
    const apiPart = `organisations/${org.networkId}/deactivate`;
    fc.delete(window.APP.CONFIGURATION.VCCAPI + apiPart)
      .then(() => {
        dispatch(setOrganizationDeletionStatus(APP.LANGUAGE.API_CALL_STATUS.COMPLETED));
        dispatch(removeDeletedOrganization(org));
        cbAfterDeletion();
        const successMessage = APP.LANGUAGE.DeleteOrganization.SuccessMessage.replace('##orgName##', org.name);
        closeConfirmationModal();
        dispatch(
          displayGlobalMessage({
            text: successMessage,
            visible: true,
            messageType: APP.LANGUAGE.GlobalMessageTypes.Good,
            autoHide: true,
          })
        );
      })
      .catch(() => {
        dispatch(
          displayGlobalMessage({
            text: APP.LANGUAGE.DeleteOrganization.ErrorMessage,
            visible: true,
            messageType: APP.LANGUAGE.GlobalMessageTypes.Bad,
            autoHide: true,
          })
        );
      })
      .finally(() => {
        dispatch(setMeetingRoomsDeletionStatus(APP.LANGUAGE.API_CALL_STATUS.NOT_STARTED));
        dispatch(setWaitingRoomsDeletionStatus(APP.LANGUAGE.API_CALL_STATUS.NOT_STARTED));
        dispatch(setOrganizationDeletionStatus(APP.LANGUAGE.API_CALL_STATUS.NOT_STARTED));
      });
  };
}

export function deleteOrganizationMeetingRooms(org, closeConfirmationModal, cbAfterDeletion) {
  return (dispatch) => {
    dispatch(setMeetingRoomsDeletionStatus(APP.LANGUAGE.API_CALL_STATUS.IN_PROGRESS));
    const apiPart = `organisations/${org.networkId}/deactivatemeetingrooms`;
    fc.delete(window.APP.CONFIGURATION.VCCAPI + apiPart)
      .then(() => {
        dispatch(setMeetingRoomsDeletionStatus(APP.LANGUAGE.API_CALL_STATUS.COMPLETED));
        dispatch(deleteOrganization(org, closeConfirmationModal, cbAfterDeletion));
      })
      .catch(() => {
        dispatch(
          displayGlobalMessage({
            text: APP.LANGUAGE.DeleteOrganization.ErrorMessage,
            visible: true,
            messageType: APP.LANGUAGE.GlobalMessageTypes.Bad,
            autoHide: true,
          })
        );
        dispatch(setMeetingRoomsDeletionStatus(APP.LANGUAGE.API_CALL_STATUS.NOT_STARTED));
      });
  };
}

export function initializeOrgDeletion(org, closeConfirmationModal, cbAfterDeletion) {
  return (dispatch) => {
    dispatch(setWaitingRoomsDeletionStatus(APP.LANGUAGE.API_CALL_STATUS.IN_PROGRESS));
    const apiPart = `organisations/${org.networkId}/deactivateAllWaitingAreas`;
    fc.delete(window.APP.CONFIGURATION.VCCAPI + apiPart)
      .then(() => {
        dispatch(setWaitingRoomsDeletionStatus(APP.LANGUAGE.API_CALL_STATUS.COMPLETED));
        dispatch(deleteOrganizationMeetingRooms(org, closeConfirmationModal, cbAfterDeletion));
      })
      .catch(() => {
        dispatch(
          displayGlobalMessage({
            text: APP.LANGUAGE.DeleteOrganization.ErrorMessage,
            visible: true,
            messageType: APP.LANGUAGE.GlobalMessageTypes.Bad,
            autoHide: true,
          })
        );
        dispatch(setWaitingRoomsDeletionStatus(APP.LANGUAGE.API_CALL_STATUS.NOT_STARTED));
      });
  };
}

export function updateOrgUnitGeneralInfoForm(updatedOrgUnitGeneralInfoForm) {
  return (dispatch) => {
    dispatch({
      type: GENERAL_INFO_FORM.UPDATE_EDIT_GENERAL_INFO_FORM,
      data: updatedOrgUnitGeneralInfoForm,
    });
  };
}

export function saveOrgUnitGeneralInfoForm(organisationId, updatedOrgUnitGeneralInfoForm, cb) {
  return (dispatch) => {
    let payload = {
      name: updatedOrgUnitGeneralInfoForm.name,
      abbreviatedName: updatedOrgUnitGeneralInfoForm.abbreviatedName,
      termsAndConditionUrl: updatedOrgUnitGeneralInfoForm.termsAndConditionUrl,
      troubleshootingUrl: updatedOrgUnitGeneralInfoForm.troubleshootingUrl,
      privacyPolicyUrl: updatedOrgUnitGeneralInfoForm.privacyPolicyUrl,
      callerEntryPage: updatedOrgUnitGeneralInfoForm.callerEntryPage,
      featuresEnabled: updatedOrgUnitGeneralInfoForm.featuresEnabled,
      providerUrl: updatedOrgUnitGeneralInfoForm.providerUrl,
    };
    let apiPath = 'organisations/' + organisationId + '/Generalinfo';
    fc.put(window.APP.CONFIGURATION.VCCAPI + apiPath, {
      body: JSON.stringify(payload),
    })
      .then((response) => {
        var successMessage = APP.LANGUAGE.OrgUnitGeneralInfo.SuccessUpdateMessage.replace(
          '##orgname##',
          updatedOrgUnitGeneralInfoForm.name
        );
        dispatch(
          displayGlobalMessage({
            text: successMessage,
            visible: true,
            messageType: APP.LANGUAGE.GlobalMessageTypes.Good,
            autoHide: true,
          })
        );
        if (cb) cb(false);
      })
      .catch((err) => {
        if (err == 'OrgNameDuplicate') {
          let orgNameDuplicate = APP.LANGUAGE.OrgUnitGeneralInfo.OrgNameDuplicateBadMessage.replace(
            '##name##',
            updatedOrgUnitGeneralInfoForm.name
          );
          dispatch(
            displayGlobalMessage({
              text: orgNameDuplicate,
              visible: true,
              messageType: APP.LANGUAGE.GlobalMessageTypes.Bad,
              autoHide: false,
              apiURL: window.APP.CONFIGURATION.VCCAPI + apiPath,
              browserURL: window.location.href,
            })
          );
        }
        if (cb) cb(true, err);
        console.error('There was an API error', err.toString());
      });
  };
}

export function orgNameDuplicate(isDuplicate) {
  return (dispatch) => {
    return dispatch({
      type: GENERAL_INFO_FORM.ORG_NAME_DUPLICATE,
      data: isDuplicate,
    });
  };
}

export function setOrgGeneralInfoFormTrim() {
  return (dispatch) => {
    dispatch({
      type: GENERAL_INFO_FORM.SET_ORG_UNIT_GENERAL_INFO_FORM_TRIM,
    });
  };
}

export function clearOrgGeneralInfoForm(cb) {
  return (dispatch) => {
    dispatch({
      type: CLEAR_ORG_UNIT_GENERAL_INFO_FORM,
    });
    if (cb) cb();
  };
}

// Support contact
export function getOrgUnitSupportContactInfo(networkId, cb) {
  return (dispatch) => {
    const apiParam = 'organisations/' + networkId + '/OrganisationSupportSetting';
    fc.get(window.APP.CONFIGURATION.VCCAPI + apiParam)
      .then((data) => {
        dispatch({
          type: ORG_UNIT_SUPPORT_CONTACT.GOT_ORG_UNIT_SUPPORT_CONTACT_INFO,
          data: data,
        });
        if (cb) cb();
      })
      .catch((err) => {
        console.error('There was an API error', err.toString());
      });
  };
}

export function changeOrgUnitSupportContact(supportcontactForm) {
  return (dispatch) => {
    dispatch({
      type: ORG_UNIT_SUPPORT_CONTACT.CHANGE_ORG_UNIT_SUPPORT_CONTACT_INFO,
      data: supportcontactForm,
    });
  };
}

export function updateOrgUnitSupportContact(orgUnit, supportcontactForm, cb) {
  return (dispatch) => {
    let payload = {
      organisaionSupportName: supportcontactForm.organisaionSupportName,
      organisaionSupportEmail: supportcontactForm.organisaionSupportEmail,
      organisaionSupportPhone: supportcontactForm.organisaionSupportPhone,
      organisaionSupportWebsite: supportcontactForm.organisaionSupportWebsite,
      moreAssistance: supportcontactForm.moreAssistance,
    };
    const apiParam = 'organisations/' + orgUnit.networkId + '/OrganisationSupportSetting';
    fc.put(window.APP.CONFIGURATION.VCCAPI + apiParam, {
      body: JSON.stringify(payload),
    })
      .then((data) => {
        if (cb) cb(false);
        dispatch(
          displayGlobalMessage({
            text: APP.LANGUAGE.OrgUnitSupportContact.SuccessfulMessage.replace('##orgname##', orgUnit.name),
            visible: true,
            messageType: APP.LANGUAGE.GlobalMessageTypes.Good,
            autoHide: true,
          })
        );
      })
      .catch((err) => {
        console.error('There was an API error', err.toString());
        if (cb) {
          cb(true);
        }
      });
  };
}

///////////////////// update organisational Unit Logo////////////////////////
export function updateOrganisationalUnitLogoImage(orgNetworkId, logoImage, isChanged = true, orgName, cb) {
  return (dispatch) => {
    let apiParam = 'organisations/' + orgNetworkId + '/UpdateImagesInfo';
    dispatch({ type: UPDATE_ORGANISATIONAL_UNIT_LOGO_IMAGE });
    fc.put(window.APP.CONFIGURATION.VCCAPI + apiParam, {
      body: JSON.stringify({
        orgLogo: logoImage,
        isChanged: isChanged,
      }),
    })
      .then((res) => {
        let successMessage = APP.LANGUAGE.DefaultOrgLogo.SuccessSave.replace('##OrganisationalUnit##', orgName);
        dispatch({ type: UPDATED_ORGANISATIONAL_UNIT_LOGO_IMAGE });
        dispatch(showOrganisationalUnitLogoImageModal(false));
        dispatch(
          displayGlobalMessage({
            text: successMessage,
            visible: true,
            messageType: APP.LANGUAGE.GlobalMessageTypes.Good,
            autoHide: true,
          })
        );

        if (cb) cb(true);
      })
      .catch((err) => {
        if (cb) cb(false);
        dispatch({ type: UPDATE_ORGANISATIONAL_UNIT_LOGO_IMAGE });
        console.error('There was an API error', err.toString());
      });
  };
}

export function getOrganisationalUnitLogoImage(orgNetworkId, cb) {
  return (dispatch) => {
    dispatch({ type: GET_ORGANISATIONAL_UNIT_LOGO_IMAGE });
    var apiPart = 'organisations/' + orgNetworkId + '/orgLogo';
    fc.get(window.APP.CONFIGURATION.VCCAPI + apiPart)
      .then((data) => {
        let res = dispatch({
          type: GOT_ORGANISATIONAL_UNIT_LOGO_IMAGE,
          data: data,
        });
        if (cb) cb();
        return res;
      })
      .catch((err) => console.error('There was an error getting the waiting areas Logo Pause Image', err.toString()));
  };
}

export function updateOrganisationalUnitLogoImageForm(updatedForm) {
  return (dispatch) => {
    dispatch({
      type: UPDATE_ORGANISATIONAL_UNIT_LOGO_IMAGE_FORM,
      data: updatedForm,
    });
  };
}

////////////////////End Organisational Unit Logo ///////////////////////////

// Org Unit Before Calls
export function getOrgUnitBeforeCallsForWA(orgNetworkId, cb) {
  return (dispatch) => {
    dispatch({ type: GET_ORGANISATIONAL_UNIT_BEFORE_CALLS_FOR_WA });
    var apiPart = 'organisations/' + orgNetworkId + '/waitingareas/ImportantInfo';

    fc.get(window.APP.CONFIGURATION.VCCAPI + apiPart)
      .then((data) => {
        let res = dispatch({
          type: GOT_ORGANISATIONAL_UNIT_BEFORE_CALLS_FOR_WA,
          data: data,
        });
        if (cb) cb();
        return res;
      })
      .catch((err) => console.error('There was an API error', err.toString()));
  };
}

export function updateBeforeCallsFormForWA(value, showCharLimitWarning, ifTextEmpty) {
  return (dispatch) => {
    return dispatch({
      type: MODIFIED_ORGANISATIONAL_UNIT_BEFORE_CALLS_FOR_WA,
      data: {
        value: value,
        showCharLimitWarning: showCharLimitWarning,
        ifTextEmpty: ifTextEmpty,
      },
    });
  };
}

export function updateOrgUnitBeforeCallsForWA(org, beforeCallDetailValue, cb) {
  return (dispatch) => {
    fc.put(`${window.APP.CONFIGURATION.VCCAPI}organisations/${org.networkId}/waitingareas/ImportantInfo`, {
      body: JSON.stringify(beforeCallDetailValue),
    })
      .then((data) => {
        if (cb) {
          cb(true);
        }
        let successMessage = APP.LANGUAGE.OrgUnitDefaultBeforeCallsForWA.SuccessfulMessage.replace(
          '##orgName##',
          org.name
        );
        dispatch(
          displayGlobalMessage({
            text: successMessage,
            visible: true,
            messageType: APP.LANGUAGE.GlobalMessageTypes.Good,
            autoHide: true,
          })
        );
      })
      .catch((err, resp) => {
        console.error('There was an API error', err.toString());
        if (cb) {
          cb(false);
        }
      });
  };
}

// Entity admin
export function getEntitiesWithSearchTerm(entityAdminPayload, filterValue, cb) {
  return (dispatch) => {
    let gotFilterValue = filterValue;
    let gotEntityAdminPayload = entityAdminPayload;
    let gotCB = cb;
    if (!!gotEntityAdminPayload === false) {
      entityAdminPayload = {
        searchString: getEntityCurrentSearchTerm(),
        pageNo: 1,
      };
      gotEntityAdminPayload = {
        searchString: getEntityCurrentSearchTerm(),
        pageNo: 1,
        searchedEntityType: window.getState().organisationsReducer.entitySearchForm.searchedEntityType,
      };
    }
    if (!!gotFilterValue === false) {
      // If filterValue is not provided, check filtervalue in entityAdminPayload
      let gotFilterName = gotEntityAdminPayload.searchedEntityType;
      if (!!gotFilterName) {
        if (gotFilterName === 'org') {
          gotFilterValue = 1;
        } else if (gotFilterName === 'wa') {
          gotFilterValue = 2;
        } else if (gotFilterName === 'mr') {
          gotFilterValue = 3;
        }
      } else {
        gotFilterValue = 1;
      }
    }

    if (!!gotCB === false) {
      gotCB = (moreEntitiesReturned) => {
        if (moreEntitiesReturned) {
          // Once data fetch finishes and fetched meetingrooms.length > 0, the active page no needs to be increased by 1
          dispatch(updateCurrentActivePageNo(1));
        }
      };
    }

    switch (gotFilterValue) {
      case 1:
        // If filter is on Org && search term is empty, we will call POST /vccapi/organisations/OrganisationalUnits
        // which will not return any child entities within each org
        if (gotEntityAdminPayload.searchString === '') {
          dispatch(getOrgsWithPagination(gotEntityAdminPayload, gotCB));
        } else {
          // If filter is on Org && with a search term, we will call POST /vccapi/organisations/searchOrganisationalUnits
          // which will return any matched child entities within each org and open the tree view
          dispatch(getAllMatchedEntitiesWithPagination(gotEntityAdminPayload, gotCB));
        }
        break;
      case 2:
        // If filter is on WA, we will call POST /waitingareas/waitingareasadministration
        dispatch(getWaitingAreasWithPagination(gotEntityAdminPayload, gotCB));
        break;
      case 3:
        // If filter is on MR, we will call POST /waitingareas/waitingareasadministration
        dispatch(getMeetingRoomsWithPagination(gotEntityAdminPayload, gotCB));
        break;
      default:
        dispatch(getOrgsWithPagination(gotEntityAdminPayload, gotCB));
        break;
    }
  };
}
export function getOrgsWithPagination(entityAdminPayload, cb) {
  // It only returns org units
  return (dispatch) => {
    let errorCallback = (response) => {
      console.error('ERROR', response);
      dispatch({ type: ERROR_GETTING_ALL_ENTITIES });
    };

    // This is called from pubnub updates, and will pass orgSearchPayLoad as null
    if (entityAdminPayload == null) {
      entityAdminPayload = {
        searchString: getEntityCurrentSearchTerm(),
        pageNo: 1,
      };
    }

    const apiPart = 'organisations/organisationalUnits';
    fc.post(window.APP.CONFIGURATION.VCCAPI + apiPart, {
      body: JSON.stringify(entityAdminPayload),
    })
      .then((data) => {
        // Data need to do checking, if there are duplicate orgs then do not need to put in the store.
        // Only store the new fetched orgs
        let passData = {
          ...data,
          pageNo: entityAdminPayload.pageNo,
          searchedEntityType: 'org',
        };
        let res = dispatch({
          type: GOT_ALL_ENTITIES_PAGINATION,
          data: passData,
        });

        if (cb) {
          if (
            !!data.organisationalUnits &&
            Array.isArray(data.organisationalUnits) &&
            data.organisationalUnits.length > 0
          ) {
            // If still more orgs can be retrieved, set first argument to be true
            cb(true, true);
          }
          // else, set first argument to be false means should not increase current active page no.
          else cb(false, true);
        }
        return res;
      })
      .catch((err) => {
        if (cb) cb(false, false);
        errorCallback(err);
      });
  };
}

export function getAllMatchedEntitiesWithPagination(entityAdminPayload, cb) {
  // This function will return child matched leaves
  return (dispatch) => {
    let errorCallback = (response) => {
      console.error('ERROR', response);
      dispatch({ type: ERROR_GETTING_ALL_ENTITIES });
    };

    if (entityAdminPayload == null) {
      entityAdminPayload = {
        searchString: getEntityCurrentSearchTerm(),
        pageNo: 1,
      };
    }

    const apiPart = 'organisations/searchOrganisationalUnits';
    fc.post(window.APP.CONFIGURATION.VCCAPI + apiPart, {
      body: JSON.stringify(entityAdminPayload),
    })
      .then((data) => {
        let passData = {
          ...data,
          pageNo: entityAdminPayload.pageNo,
          searchedEntityType: 'org',
        };
        let res = dispatch({
          type: GOT_ALL_ENTITIES_PAGINATION,
          data: passData,
        });

        if (cb) {
          if (
            !!data.organisationalUnits &&
            Array.isArray(data.organisationalUnits) &&
            data.organisationalUnits.length > 0
          ) {
            // If still more orgs can be retrieved, set first argument to be true
            cb(true, true);
          }
          // else, set first argument to be false means should not increase current active page no.
          else cb(false, true);
        }
        return res;
      })
      .catch((err) => {
        if (cb) cb(false, false);
        errorCallback(err);
      });
  };
}

export function getWaitingAreasWithPagination(entityAdminPayload, cb) {
  return (dispatch) => {
    let errorCallback = (response) => {
      console.error('ERROR', response);
      dispatch({ type: ERROR_GETTING_ALL_ENTITIES });
    };

    if (entityAdminPayload == null) {
      entityAdminPayload = {
        searchString: getEntityCurrentSearchTerm(),
        pageNo: 1,
      };
    }

    const apiPart = 'waitingareas/waitingareasadministration';
    fc.post(window.APP.CONFIGURATION.VCCAPI + apiPart, {
      body: JSON.stringify(entityAdminPayload),
    })
      .then((data) => {
        // Data need to do checking, if there are duplicate orgs then do not need to put in the store.
        // Only store the new fetched orgs
        let passData = {
          ...data,
          pageNo: entityAdminPayload.pageNo,
          searchedEntityType: 'wa',
        };
        let res = dispatch({
          type: GOT_ALL_ENTITIES_PAGINATION,
          data: passData,
        });

        if (cb) {
          if (
            !!data.organisationalUnits &&
            Array.isArray(data.organisationalUnits) &&
            data.organisationalUnits.length > 0
          ) {
            // If still more orgs can be retrieved, set first argument to be true
            cb(true, true);
          }
          // else, set first argument to be false means should not increase current active page no.
          else cb(false, true);
        }
        return res;
      })
      .catch((err) => {
        if (cb) cb(false, false);
        errorCallback(err);
      });
  };
}

export function getMeetingRoomsWithPagination(entityAdminPayload, cb) {
  return (dispatch) => {
    let errorCallback = (response) => {
      console.error('ERROR', response);
      dispatch({ type: ERROR_GETTING_ALL_ENTITIES });
    };

    if (entityAdminPayload == null) {
      entityAdminPayload = {
        searchString: getEntityCurrentSearchTerm(),
        pageNo: 1,
      };
    }

    const apiPart = 'meetingrooms/meetingroomsadministration';
    fc.post(window.APP.CONFIGURATION.VCCAPI + apiPart, {
      body: JSON.stringify(entityAdminPayload),
    })
      .then((data) => {
        // Data need to do checking, if there are duplicate orgs then do not need to put in the store.
        // Only store the new fetched orgs
        let passData = {
          ...data,
          pageNo: entityAdminPayload.pageNo,
          searchedEntityType: 'mr',
        };
        let res = dispatch({
          type: GOT_ALL_ENTITIES_PAGINATION,
          data: passData,
        });

        if (cb) {
          if (
            !!data.organisationalUnits &&
            Array.isArray(data.organisationalUnits) &&
            data.organisationalUnits.length > 0
          ) {
            // If still more orgs can be retrieved, set first argument to be true
            cb(true, true);
          }
          // else, set first argument to be false means should not increase current active page no.
          else cb(false, true);
        }
        return res;
      })
      .catch((err) => {
        if (cb) cb(false, false);
        errorCallback(err);
      });
  };
}

export function resetEntitySearchForm(cb) {
  return (dispatch) => {
    dispatch({ type: RESET_ENTITY_SEARCH_FROM });
    if (cb) cb();
  };
}

export function updateEntitySearchForm(newEntitySearchForm) {
  return (dispatch) => {
    dispatch({ type: UPDATE_ENTITY_SEARCH_FROM, data: newEntitySearchForm });
  };
}

export function updateCurrentActivePageNo(updateOffset, cb) {
  return (dispatch) => {
    dispatch({
      type: UPDATE_CURRENT_ACTIVE_PAGENO_FOR_ENTITY_PAGE,
      data: updateOffset,
    });
    if (cb) cb();
  };
}

export function updateIsOnEntityListingPage(isOnEntityPage) {
  return (dispatch) => {
    dispatch({ type: IS_ON_ENTITY_LISTING_PAGE, data: isOnEntityPage });
  };
}

export function getEntityCurrentSearchTerm() {
  let organisationsReducer = window.getState().organisationsReducer;
  let searchTerm = organisationsReducer.entitySearchForm.searchString;
  searchTerm = typeof searchTerm != 'string' || searchTerm == null || searchTerm == undefined ? '' : searchTerm.trim();
  return searchTerm;
}

export function getCurrentSearchEntityType() {
  let organisationsReducer = window.getState().organisationsReducer;
  let entityType = organisationsReducer.entitySearchForm.searchedEntityType;
  entityType = typeof entityType != 'string' || entityType == null || entityType == undefined ? 'org' : entityType;
  return entityType;
}

export function getOrgUnitWithSearchTerm(networkId, cb) {
  return (dispatch) => {
    let searchTerm = getEntityCurrentSearchTerm();
    dispatch({ type: GET_ORGANISATION });

    fc.post(window.APP.CONFIGURATION.VCCAPI + 'organisations/organisationalUnits/' + networkId, {
      body: JSON.stringify(searchTerm),
    })
      .then((data) => {
        let res = dispatch({ type: GOT_ORGANISATION, data: data });
        if (cb) cb();
        return res;
      })
      .catch((err) => {
        console.error('There was an API error', err.toString());
        dispatch({ type: ERROR_GET_ORGANISATION });
        // If this meeting room does not exist, need to check it state.meetingrooms has it
        // If it exists in state.meetingrooms then remove it
        if (err && err.status == 404) {
          dispatch({ type: DELETED_ORG_UNIT, data: networkId });
        }
      });
  };
}

// It is called when receiving pubnub updates "user-updated"
// And only when org unit list is chaged, this function will be called
// E.g portaladmin will not call this function if its list of org units has not changed when chaning permissions
export function getAllOrgUnits(entityAdminPayload, cb) {
  return (dispatch) => {
    let orgUnitsNumber = window.getState().organisationsReducer.organisations.length;
    let isOnEntityListingPage = window.getState().organisationsReducer.isOnEntityListingPage;
    let selectedOrgUnit = window.getState().organisationsReducer.selectedOrgUnit;
    let selectedOrgUnitId = window.getState().organisationsReducer.selectedOrgUnitId;
    if (!isOnEntityListingPage) {
      // If it's not on entity admin page, check selected org unit details
      if (
        selectedOrgUnit &&
        selectedOrgUnit.networkId != null &&
        selectedOrgUnit.networkId != undefined &&
        selectedOrgUnit.networkId != ''
      ) {
        selectedOrgUnitId = selectedOrgUnit.networkId;
      }
      if (selectedOrgUnitId && selectedOrgUnitId != null && selectedOrgUnitId != undefined && selectedOrgUnitId != '') {
        dispatch(getOrgUnitWithSearchTerm(selectedOrgUnitId));
        return;
      }
    }
  };
}

// Entity admin - Waiting Areas
// This function will be called on entity admin page with filter of "Org"
// When user click the "Show all" link or open the waiting area list in the tree view
export function getWaitingAreas(entityAdminPayload, cb) {
  return (dispatch) => {
    let errorCallback = (response) => {
      console.error('ERROR', response);
    };

    // Show busy indicator
    dispatch({
      type: IS_FETCHING_WA_ENTITIES,
      data: {
        orgUnitNetworkId: entityAdminPayload.orgUnitNetworkId,
        fetchingWaitingAreas: true,
      },
    });

    const apiPart = `organisations/${entityAdminPayload.orgUnitNetworkId}/waitingareas`;
    fc.get(window.APP.CONFIGURATION.VCCAPI + apiPart)
      .then((data) => {
        dispatch({
          type: GOT_ALL_WA_ENTITIES_PAGINATION,
          data: {
            ...data,
            pageNo: entityAdminPayload.pageNo,
            orgUnitNetworkId: entityAdminPayload.orgUnitNetworkId,
          },
        });
        if (cb) cb();
      })
      .catch((err) => {
        errorCallback(err);
      });
  };
}

export function getMeetingRooms(entityAdminPayload, cb) {
  return (dispatch) => {
    let errorCallback = (response) => {
      console.error('ERROR', response);
    };

    const apiPart = `organisations/${entityAdminPayload.orgUnitNetworkId}/meetingrooms`;
    fc.get(window.APP.CONFIGURATION.VCCAPI + apiPart)
      .then((data) => {
        dispatch({
          type: GOT_ALL_MR_ENTITIES_PAGINATION,
          data: {
            ...data,
            pageNo: entityAdminPayload.pageNo,
            orgUnitNetworkId: entityAdminPayload.orgUnitNetworkId,
          },
        });
        if (cb) cb();
      })
      .catch((err) => {
        errorCallback(err);
      });
  };
}

// It returns the latest WA and check if it meets the search term
// Depending the filter it will call different api
export function getWAByIdWithSearchTerm(waitingAreaId, originalNetworkId, cb) {
  return (dispatch) => {
    let filterEntityType = getCurrentSearchEntityType();
    if (filterEntityType === 'org') {
      // Filter is on Org
      dispatch(getWAWithFilteringOrg(waitingAreaId, originalNetworkId, cb));
    } else if (filterEntityType === 'wa') {
      // Filter is on mr
      dispatch(getWAWithFilteringWA(waitingAreaId, originalNetworkId, cb));
    }
  };
}

// When filter is on org, get WA data
// isInSearchCriteria might be different with different filters; so need to call separate api
export function getWAWithFilteringOrg(waitingAreaId, originalNetworkId, cb) {
  return (dispatch) => {
    fc.get(window.APP.CONFIGURATION.VCCAPI + 'waitingareas/' + waitingAreaId)
      .then((data) => {
        if (cb) cb(data);
        dispatch({
          type: GOT_WAITING_AREA_BY_SEARCH_TERM,
          data: data,
        });
        return;
      })
      .catch((err) => {
        console.error('There was an API error', err.toString());
        // If it exists in state.organisations then remove it
        if (err && err.status == 404 && originalNetworkId) {
          dispatch({
            type: DELETED_WAITING_AREA_FROM_ORG,
            data: {
              networkId: originalNetworkId,
              waitingAreaId: waitingAreaId,
            },
          });
        }
      });
  };
}

export function getWAWithFilteringWA(waitingAreaId, originalNetworkId, cb) {
  return (dispatch) => {
    let searchTerm = getEntityCurrentSearchTerm();
    let apiPath = 'waitingareas/waitingareasadministration/';
    fc.post(window.APP.CONFIGURATION.VCCAPI + apiPath + waitingAreaId, {
      body: JSON.stringify(searchTerm),
    })
      .then((data) => {
        if (cb) cb(data);
        return dispatch({
          type: GOT_WAITING_AREA_BY_SEARCH_TERM,
          data: data,
        });
      })
      .catch((err) => {
        console.error('There was an API error', err.toString());
        // If it exists in state.organisations then remove it
        if (err && err.status == 404 && originalNetworkId) {
          dispatch({
            type: DELETED_WAITING_AREA_FROM_ORG,
            data: {
              networkId: originalNetworkId,
              waitingAreaId: waitingAreaId,
            },
          });
        }
      });
  };
}

export function removeWAInEntityList(waitingAreaId, originalNetworkId, cb) {
  return (dispatch) => {
    dispatch({
      type: DELETED_WAITING_AREA_FROM_ORG,
      data: {
        networkId: originalNetworkId,
        waitingAreaId: waitingAreaId,
      },
    });
    if (cb) cb();
  };
}

// It returns the latest MR and check if it meets the search term
// Depending the filter it will call different api
export function getMRByIdWithSearchTerm(meetingRoomId, originalNetworkId, cb) {
  return (dispatch) => {
    let filterEntityType = getCurrentSearchEntityType();
    if (filterEntityType === 'org') {
      // Filter is on Org
      dispatch(getMRWithFilteringOrg(meetingRoomId, originalNetworkId, cb));
    } else if (filterEntityType === 'mr') {
      // Filter is on MR
      dispatch(getMRWithFilteringMR(meetingRoomId, originalNetworkId, cb));
    }
  };
}

// When filter is on org, get MR data
// isInSearchCriteria might be different with different filters; so need to call separate api
export function getMRWithFilteringOrg(meetingRoomId, originalNetworkId, cb) {
  return (dispatch) => {
    fc.get(window.APP.CONFIGURATION.VCCAPI + 'meetingrooms/' + meetingRoomId)
      .then((data) => {
        if (cb) cb(data);
        return dispatch({
          type: GOT_MEETING_ROOM_BY_ID_AND_SEARCH_TERM,
          data: data,
        });
      })
      .catch((err) => {
        console.error('There was an API error', err.toString());
        // If it exists in state.organisations then remove it
        if (err && err.status == 404 && originalNetworkId) {
          dispatch({
            type: DELETED_MEETING_ROOM_FROM_ORG,
            data: {
              networkId: originalNetworkId,
              meetingRoomId: meetingRoomId,
            },
          });
        }
      });
  };
}

export function getMRWithFilteringMR(meetingRoomId, originalNetworkId, cb) {
  return (dispatch) => {
    let searchTerm = getEntityCurrentSearchTerm();
    let apiPath = 'meetingrooms/meetingroomsadministration/';
    fc.post(window.APP.CONFIGURATION.VCCAPI + apiPath + meetingRoomId, {
      body: JSON.stringify(searchTerm),
    })
      .then((data) => {
        if (cb) cb(data);
        return dispatch({
          type: GOT_MEETING_ROOM_BY_ID_AND_SEARCH_TERM,
          data: data,
        });
      })
      .catch((err) => {
        console.error('There was an API error', err.toString());
        // If it exists in state.organisations then remove it
        if (err && err.status == 404 && originalNetworkId) {
          dispatch({
            type: DELETED_MEETING_ROOM_FROM_ORG,
            data: {
              networkId: originalNetworkId,
              meetingRoomId: meetingRoomId,
            },
          });
        }
      });
  };
}

export function removeMRInEntityList(meetingRoomId, originalNetworkId, cb) {
  return (dispatch) => {
    dispatch({
      type: DELETED_MEETING_ROOM_FROM_ORG,
      data: {
        networkId: originalNetworkId,
        meetingRoomId: meetingRoomId,
      },
    });
    if (cb) cb(true);
  };
}

// Update RHS stats
export function updateRHSTotalCount(entityType, offset) {
  return (dispatch) => {
    dispatch({
      type: UPDATE_RHS_TOTAL_COUNT,
      data: {
        offset: offset,
        entityType: entityType,
      },
    });
  };
}

// Only call when navigate to Manage Users/Tags page from entity admin page
export function updateFilterValue(filterValue) {
  return (dispatch) => {
    dispatch({
      type: UPDATE_FILTER_VALUE,
      data: filterValue,
    });
  };
}

// Default Share link message for WA
export function getShareLinkMessageForWA(networkId, cb) {
  return (dispatch) => {
    const apiParam = 'organisations/' + networkId + '/entryPointAdditionalMessageSettings';
    fc.get(window.APP.CONFIGURATION.VCCAPI + apiParam)
      .then((data) => {
        dispatch({
          type: GOT_SHARE_LINK_MESSAGE_FOR_WA,
          data: data,
        });
        if (cb) cb();
      })
      .catch((err) => {
        console.error('There was an API error', err.toString());
        // In order to handle those specific errors for GET API
        if (err === 'FeatureNotAllowed' || err === 'NoNetworkEditPermission' || err === 'NoNetworkViewPermission') {
          dispatch(
            displayGlobalMessage({
              text: APP.LANGUAGE.ShareLinkSharedText.PermissionChange,
              visible: true,
              messageType: APP.LANGUAGE.GlobalMessageTypes.Bad,
              autoHide: false,
              gotItButtonText: APP.LANGUAGE.ShareLinkSharedText.Refresh,
              gotItCallBack: () => {
                window.location.reload();
              },
            })
          );
        }
      });
  };
}

export function saveShareLinkMessageForWA(networkId, payload, cb) {
  return (dispatch) => {
    const apiPart = 'organisations/' + networkId + '/entryPointAdditionalMessageSettings';
    fc.post(window.APP.CONFIGURATION.VCCAPI + apiPart, {
      body: JSON.stringify(payload),
    })
      .then((data) => {
        if (cb) cb(true);
      })
      .catch((err, resp) => {
        if (cb) cb(false, err);
        console.error('ERROR', err);
      });
  };
}
//Recording Settingg
export const saveOURecordingSettings = (orgid, payload) => (dispatch) =>
  new Promise((resolve, reject) => {
    const apiPart = 'organisations/' + orgid + '/recording';
    fc.post(window.APP.CONFIGURATION.VCCAPI + apiPart, {
      body: JSON.stringify(payload),
    })
      .then(() => {
        let successMessage = APP.LANGUAGE.Recording.SuccessUpdateMessage;
        dispatch(
          displayGlobalMessage({
            text: successMessage,
            visible: true,
            messageType: APP.LANGUAGE.GlobalMessageTypes.Good,
            autoHide: true,
          })
        );
        resolve();
      })
      .catch((err) => {
        console.error('There was an API error', err.toString());
        // NoNetworkViewPermission
        if (err == 'NoNetworkViewPermission') {
          dispatch(
            displayGlobalMessage({
              text: APP.LANGUAGE.ConsultNow.NoNetworkViewPermission,
              visible: true,
              messageType: APP.LANGUAGE.GlobalMessageTypes.Bad,
              autoHide: false,
              gotItButtonText: APP.LANGUAGE.ShareLinkSharedText.Refresh,
              gotItCallBack: () => {
                window.location.reload();
              },
            })
          );
        }
        reject(err);
      });
  });
export function getOURecordingSetting(networkId, cb) {
  return (dispatch) => {
    const apiPart = 'organisations/' + networkId + '/isRecordingEnabled';
    fc.get(window.APP.CONFIGURATION.VCCAPI + apiPart)
      .then((data) => {
        if (cb) cb(data);
        dispatch({
          type: GOT_OURECORDING_SETTING_FEATURE,
          data: data,
        });
      })
      .catch((err, resp) => {
        if (cb) cb(false, err);
        console.error('ERROR', err);
      });
  };
}

///////////////////////////////////////////OU-GC-[CHAT-FULLNAME]-CONTROLS////////////////////////////////////////////////////////////
// Get data for OU GC Settings / FullName , ChatControls

export function getDefaultGCSettingsForOU(orgId, cb) {
  return (dispatch) => {
    const apiParam = `organisations/${orgId}/getOUGCSettings`;
    fc.get(window.APP.CONFIGURATION.VCCAPI + apiParam)
      .then((data) => {
        dispatch({ type: GOT_OU_GC_SETTINGS, data: data });
        queueESEvents(
          ESEventTypes.APICall,
          `In getDefaultGCSettingsForOU: ${orgId}`,
          'eventType&apiURL',
          {
            apiURL: window.APP.CONFIGURATION.VCCAPI + 'organisations/' + orgId + '/getOUGCSettings',
            browserURL: window.location.href,
          },
          null,
          true,
          'info'
        );
        if (cb) cb();
      })
      .catch((err) => {
        console.error('There was an API error', err.toString());
        queueESEvents(ESEventTypes.GCSettingsAPIError, err.toString());
        dispatch(defaultGCOrgErrors(err));
        if (cb) cb();
      });
  };
}
// Update Form for gc settings in default OU
export function updateGcOUSettingForm(gcOUSettingFormModified) {
  return (dispatch) => {
    return dispatch({
      type: MODIFIED_GC_OU_SETTING_FORM,
      data: gcOUSettingFormModified,
    });
  };
}
//Update call to set gc OU setting form dataToSave
export function updateGCSettingCallForOU(orgId, payload, cb) {
  return (dispatch) => {
    fc.post(`${window.APP.CONFIGURATION.VCCAPI}organisations/${orgId}/saveOUGCSettings`, {
      body: JSON.stringify(payload),
    })
      .then((data) => {
        queueESEvents(
          ESEventTypes.GCSettingsOrgUpdate,
          `In updateGCSettingCallForOU: ${JSON.stringify(payload)}`,
          'eventType&apiURL',
          {
            apiURL: window.APP.CONFIGURATION.VCCAPI + 'organisations/' + orgId + '/saveOUGCSettings',
            browserURL: window.location.href,
            orgId: orgId,
          },
          null,
          true,
          'info'
        );
        if (cb) {
          cb();
        }
        dispatch(
          displayGlobalMessage({
            text: APP.LANGUAGE.OrganisationalUnitDefaultGroupConsultiationSettings.SuccessUpdateMessage,
            visible: true,
            messageType: APP.LANGUAGE.GlobalMessageTypes.Good,
            autoHide: true,
          })
        );
      })
      .catch((err, resp) => {
        queueESEvents(ESEventTypes.GCSettingsUpdateAPIError, err.toString());
        dispatch(defaultGCOrgErrors(err));
        if (cb) {
          cb();
        }
      });
  };
}
export function defaultGCOrgErrors(err) {
  return (dispatch) => {
    if (err == 'Invalid request') {
      dispatch(
        displayGlobalMessage({
          text: APP.LANGUAGE.GCSettings.InvalidRequest,
          visible: true,
          messageType: APP.LANGUAGE.GlobalMessageTypes.Bad,
          autoHide: true,
        })
      );
    }
    if (err == 'FeatureNotAllowed') {
      dispatch(
        displayGlobalMessage({
          text: APP.LANGUAGE.GCSettings.FeatureNotAllowed,
          visible: true,
          messageType: APP.LANGUAGE.GlobalMessageTypes.Bad,
          autoHide: true,
        })
      );
    }
    if (err == 'OrgGCSettingNotAllowed') {
      dispatch(
        displayGlobalMessage({
          text: APP.LANGUAGE.GCSettings.OrgGCSettingNotAllowed,
          visible: true,
          messageType: APP.LANGUAGE.GlobalMessageTypes.Bad,
          autoHide: true,
        })
      );
    }
    if (err == 'AccessDenied') {
      dispatch(
        displayGlobalMessage({
          text: APP.LANGUAGE.GCSettings.AccessDenied,
          visible: true,
          messageType: APP.LANGUAGE.GlobalMessageTypes.Bad,
          autoHide: true,
        })
      );
    }
    if (err == 'GCWaitingAreaCallsInProgress ') {
      dispatch(
        displayGlobalMessage({
          text: APP.LANGUAGE.GCSettings.GCWaitingAreaCallsInProgress,
          visible: true,
          messageType: APP.LANGUAGE.GlobalMessageTypes.Bad,
          autoHide: true,
        })
      );
    }
    if (err == 'NetworkNotFound') {
      dispatch(
        displayGlobalMessage({
          text: APP.LANGUAGE.GCSettings.NetworkNotFound,
          visible: true,
          messageType: APP.LANGUAGE.GlobalMessageTypes.Bad,
          autoHide: true,
        })
      );
    }
  };
}
